import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { fetchThumbnailUrl } from '../../../services/media';

interface Props {
  src: string;
}

export const VimeoThumbnail = ({ src }: Props) => {
  const { t } = useTranslation(['products']);
  const { data } = useQuery({
    queryFn: async () => fetchThumbnailUrl(src),

    queryKey: ['vimeo_thumbnail', src],
  });

  return <img src={data} alt={t('products:product_video')} className="h-full w-full object-cover" />;
};
